import dayjs from 'dayjs';

// Estado efectivo de un artículo, con las mismas reglas y en el mismo orden que
// usa la columna "Estado" de la Lista de Contenido: un borrador manda sobre
// todo lo demás, y una fecha futura convierte cualquier otro estado en
// programada.
export const getArticleStatus = (article) => {
  if (!article) return 'active';
  if (article.status === 'draft') return 'draft';
  if (article.date && dayjs(article.date).isAfter(dayjs())) return 'scheduled';
  if (article.status === 'published') return 'published';
  if (article.status === 'scheduled') return 'scheduled';
  return 'active';
};

export const STATUS_LABELS = {
  draft: 'Borrador',
  scheduled: 'Programada',
  published: 'Publicado',
  active: 'Activo',
};

export default getArticleStatus;
